<mat-toolbar class="header bg-white">
  <img class="w-logo" src="assets/svg/logo-broadfactor-colorido.svg" alt="Logo da Broadfactor">
</mat-toolbar>
